import { ReactNode } from "react";

import { useSelector } from "react-redux";
import { UserRoles } from "../common/constants/UserRoles";
import { selectUserInfo } from "../redux/User";
import Footer from "./footer";
import Header from "./header";
import AdminSidebar from "./sidebar/AdminSidebar";

const Layout = ({ children }: { children: ReactNode }) => {
  const { userInfo } = useSelector((store: any) => ({
    userInfo: selectUserInfo(store),
  }));

  const getSidebarByRole = (userRoles: any) => {
    return [{ role: UserRoles.ADMIN, sidebar: <AdminSidebar /> }].find((it) =>
      userRoles.includes(it.role)
    )?.sidebar;
  };

  return (
    <div id="page-top">
      <div id="wrapper">
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <div className="container-scroller">
              <Header />
              <div className="container-fluid page-body-wrapper pt-25 proBanner-padding-top">
                {getSidebarByRole(userInfo.roles)}
                {children}
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>

      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
    </div>
  );
};

export default Layout;
